/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, October 22nd 2021, 11:02:40 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */
/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, September 22nd 2021, 11:44:01 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import MenuList from "@mui/material/MenuList";
import ListItemIcon from "@mui/material/ListItemIcon";
import Popover from "@mui/material/Popover";
import { OSAvatar } from "ui-widgets";
import { useGlobalScope } from "core/providers";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { resolveURLName } from "core/routes/utils";
import { EXCLUDED_URLS, URLS } from "core/routes";

/* Feather Icons */
import { Settings } from "react-feather";
import { Hexagon } from "react-feather";
import { LogOut } from "react-feather";

export const UserProfilePopOver = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { logoutUser, loggedInUser } = useGlobalScope().userContext;

  const navigate = useNavigate();

  const goToWorkerProfile = () => {
    navigate(resolveURLName("viewWorker", { workerId: loggedInUser.id }));
    handleClose();
  };

  const goToBilling = () => {
    navigate(resolveURLName("billing"));
    handleClose();
  };

  const showManageBilling = !EXCLUDED_URLS.includes(URLS.billing);

  return (
    <>
      <Tooltip title={`${loggedInUser?.first_name} ${loggedInUser?.last_name}`}>
        {/* eslint-disable-next-line */}
        <a className="user-icon" onClick={handleClick}>
          <OSAvatar
            name={
              loggedInUser?.first_name === ""
                ? loggedInUser?.username
                : `${loggedInUser?.first_name} ${loggedInUser?.last_name}`
            }
            imageSrc={loggedInUser.registrationprofile?.image}
            splitFirstOnly={false}
            sx={{ bgcolor: "transparent" }}
          />
        </a>
      </Tooltip>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Paper sx={{ width: 160 }}>
          <MenuList className="user-popup" dense>
            <MenuItem onClick={goToWorkerProfile}>
              <ListItemIcon className="user-popup-icon">
                <Hexagon />
              </ListItemIcon>
              Profile
            </MenuItem>
            {showManageBilling ? (
              <MenuItem onClick={goToBilling}>
                <ListItemIcon className="user-popup-icon">
                  <Settings />
                </ListItemIcon>
                Manage Billing
              </MenuItem>
            ) : null}

            <MenuItem className="user-popup-logout" onClick={logoutUser}>
              <ListItemIcon className="user-popup-icon">
                <LogOut />
              </ListItemIcon>
              Logout
            </MenuItem>
          </MenuList>
        </Paper>
      </Popover>
    </>
  );
};
